import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { Relatorio, RelatorioCliente, RelatorioOrcamentoVenda } from '../models/relatorios';
import { GlobalService } from './global.service';
import { CRMFiltroAtividade } from 'src/app/models/crm/crmfiltro-atividade';
import { CRMFiltroOportunidade } from 'src/app/models/crm/crmfiltro-oportunidade';

@Injectable({
  providedIn: 'root'
})
export class RelatorioService {

  constructor(private http: HttpClient, private globalService: GlobalService) {

  }

  pedido(idCupom) {
    let parametros = new HttpParams()
      .set('idCupom', idCupom)
    ;

    return this.http.get(globals.apiUrl + '/api/Relatorio/Pedido',
      { params: parametros, responseType: 'blob' });
  }

  resumoDoPedido(monitor, idCupom, ocultarValores, mostrarDescontoItens) {
    let parametros = new HttpParams()
      .set('idCupom', idCupom)
      .set('ocultarValores', ocultarValores)
      .set('mostrarDescontoItens', mostrarDescontoItens)
      .set('monitor', monitor);

    return this.http.get(globals.apiUrl + '/api/Relatorio/ResumoDoPedido',
      { params: parametros, responseType: 'blob' });
  }

  relatorioDeClientes(relatorio: RelatorioCliente) {

    let parametros = new HttpParams().set('exportacao', relatorio.exportacao.toString());

    if (relatorio.cidade) {
      parametros = parametros.set('cid', relatorio.cidade);
    }

    if (relatorio.dtini) {
      parametros = parametros.set('dtini', relatorio.dtini.toLocaleDateString());
    }

    if (relatorio.dtfim) {
      parametros = parametros.set('dtfim', relatorio.dtfim.toLocaleDateString());
    }

    if (relatorio.vendedor && relatorio.vendedor !== null) {
      parametros = parametros.set('vendedor', relatorio.vendedor.toString());
    }

    if (relatorio.segm) {
      parametros = parametros.set('idClassificacao', relatorio.segm.toString());
    }

    if (relatorio.idFornecedor) {
      parametros = parametros.set('idFornecedor', relatorio.idFornecedor.toString());
    }

    return this.http.get(globals.apiUrl + '/api/Relatorio/' + relatorio.metodo,
      { params: parametros, responseType: 'blob' });
  }

  relatorioDeOrcamentosVendas(relatorio: RelatorioOrcamentoVenda) {

    let parametros = new HttpParams().set('exportacao', relatorio.exportacao.toString());

    if (relatorio.idFornecedor) {
      parametros = parametros.set('idFornecedor', relatorio.idFornecedor.toString());
    }

    if (relatorio.dtini) {
      parametros = parametros.set('dtini', relatorio.dtini.toLocaleDateString());
    }

    if (relatorio.dtfim) {
      parametros = parametros.set('dtfim', relatorio.dtfim.toLocaleDateString());
    }

    if (relatorio.cli) {
      parametros = parametros.set('cli', relatorio.cli.id.toString());
    }

    if (relatorio.dataCriacao) {
      parametros = parametros.set('dataCriacao', relatorio.dataCriacao.toString());
    }

    if (relatorio.aprovadosFinanceiro) {
      parametros = parametros.set('aprovadosFinanceiros', relatorio.aprovadosFinanceiro.toString());
    }

    if (relatorio.somenteOrcamentos) {
      parametros = parametros.set('somenteOrcamentos', relatorio.somenteOrcamentos.toString());
    }

    if (relatorio.painelInversor) {
      parametros = parametros.set('painelInversor', relatorio.painelInversor.toString());
    }

    if (relatorio.idEtapa) {
      parametros = parametros.set('idEtapa', relatorio.idEtapa.toString());
    }

    if (relatorio.statusOrcamento) {
      parametros = parametros.set('statusOrcamento', relatorio.statusOrcamento.toString());
    }

    if (relatorio.familia) {
      parametros = parametros.set('familia', relatorio.familia.toString());
    }

    if (relatorio.categoria) {
      parametros = parametros.set('categoria', relatorio.categoria.toString());
    }

    if (relatorio.etapas) {
      parametros = parametros.set('etapas', relatorio.etapas);
    }

    if (relatorio.tipoEstrutura !== undefined && relatorio.tipoEstrutura !== null) {
      parametros = parametros.set('tipoEstrutura', relatorio.tipoEstrutura.toString());
    }

    if (relatorio.tipoFiltroDataMonitor !== undefined && relatorio.tipoFiltroDataMonitor !== null) {
      parametros = parametros.set('tipoFiltroDataMonitor', relatorio.tipoFiltroDataMonitor.toString());
    }

    if (relatorio.statusInterno !== undefined && relatorio.statusInterno !== null) {
      parametros = parametros.set('statusInterno', relatorio.statusInterno.toString());
    }

    if (relatorio.tipoFiltroDataPedido !== undefined && relatorio.tipoFiltroDataPedido !== null) {
      parametros = parametros.set('tipoFiltroDataPedido', relatorio.tipoFiltroDataPedido.toString());
    }

    if (relatorio.tipoRelatorio !== undefined && relatorio.tipoRelatorio !== null) {
      parametros = parametros.set('tipoRelatorio', relatorio.tipoRelatorio.toString());
    }

    if (relatorio.aplicadorCupom !== undefined && relatorio.aplicadorCupom !== null) {
      parametros = parametros.set('aplicadorCupom', relatorio.aplicadorCupom.toString());
    }

    if (relatorio.revisao !== undefined && relatorio.revisao !== null) {
      parametros = parametros.set('revisao', relatorio.revisao.toString());
    }

    if (relatorio.uf !== undefined && relatorio.uf !== null) {
      parametros = parametros.set('uf', relatorio.uf);
    }

    if (relatorio.cidade !== undefined && relatorio.cidade !== null) {
      parametros = parametros.set('cidade', relatorio.cidade);
    }

    const funcionario = Number(relatorio.usu) === 0 ? '' :
      Number(relatorio.usu) === -1 ? relatorio.idUsuarioLogado :
        relatorio.usu;

    if (funcionario) {
      parametros = parametros.set('usu', funcionario.toString()).set('tipo', '0');
    } else {
      parametros = parametros.set('tipo', '1');
    }

    parametros = parametros.set('flag', !relatorio.flag ? '0' : relatorio.flag);

    return this.http.get(globals.apiUrl + '/api/Relatorio/' + relatorio.metodo,
      { params: parametros, responseType: 'blob' });

  }

  relatorioDeAtividades(filtro: CRMFiltroAtividade) {
    return this.http.post(globals.apiUrl + '/api/Relatorio/Atividades', filtro,
      { responseType: 'blob' });
  }

  relatorioDeOportunidades(filtro: CRMFiltroOportunidade) {
    return this.http.post(globals.apiUrl + '/api/Relatorio/Oportunidades', filtro,
      { responseType: 'blob' });
  }

  relatorioDeLogCliente(idIntegrador) {
    let parametro = new HttpParams().set('idIntegrador', idIntegrador);

    return this.http.get(globals.apiUrl + '/api/Relatorio/LogCliente',
      { params: parametro, responseType: 'blob' });
  }

  buscarRelatorios(categoria) {
    return this.http.get<Relatorio[]>(globals.apiUrl + '/api/Relatorio/BuscarRelatorios',
      { params: { categoria } });
  }
}
